// import { randomHexColorWithArray } from 'random-hex-color-generator';
// import React, { useEffect, useState } from 'react';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
// import ProductReviewsTooltip from './ProductReviews.Tooltip';

function ProductReviewsGraph({ productReviewsData }) {
    // const [colors, setColors] = useState([]);

    // useEffect(() => {
    //     const colorsArray = randomHexColorWithArray(productReviewsData.length);
    //     setColors(colorsArray);
    // }, [productReviewsData]);

    return (
        <div className="border rounded-lg border-[#EAEAEA] col-span-3 min-h-[50vh] p-5 flex flex-col gap-4">
            <h1 className="font-semibold text-base">Product Reviews</h1>

            <div className="m-auto">
                <h1 className='font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>

            {/* <ResponsiveContainer width="100%" height="100%">
                <BarChart width={150} height={40} data={productReviewsData}>
                    <XAxis 
                        dataKey="name" 
                        tickLine={false} 
                        tickMargin={15} 
                        type='category' 
                    />

                    <YAxis 
                        tickCount={5} 
                        tickLine={false} 
                        tickMargin={15} 
                        type="number" 
                        unit={'%'} 
                        domain={[0, 100]} 
                    />
                    
                    <Tooltip 
                        cursor={{ fill: 'transparent' }} 
                        content={<ProductReviewsTooltip />} 
                    />
                    
                    <Bar
                        dataKey="percentage"
                        fill="#00a0fc" 
                    >
                        {
                            productReviewsData.map((_, index) => (
                                <Cell 
                                    key={`cell-${index}`} 
                                    fill={colors[index % 20]} 
                                />
                            ))
                        }
                    </Bar>
                </BarChart>
            </ResponsiveContainer> */}
        </div>
    );
}

export default ProductReviewsGraph;
